import React from "react";

import "./UserProfileHeader.css";
import { Image, Transformation } from "cloudinary-react";

/* eslint-disable react/no-unused-prop-types */
export interface UserProfileHeaderConfig {
  userHandleRenderedForm: string;
  userBio: string;
  profilePicId: string;
  userName: string;
  followersCount: number;
  followingCount: number;
}
/* eslint-enable react/no-unused-prop-types */

export const demoProps1UserProfileHeaderConfig: UserProfileHeaderConfig = {
  userHandleRenderedForm: "helloThere",
  userBio:
    "Hello, my name is inigo montoy\n.You killed my father.\nPrepare to die.",
  profilePicId: "string",
  userName: "Moishe",
  followersCount: 23,
  followingCount: 42,
};

function _ProfilePicture(props: UserProfileHeaderConfig): JSX.Element {
  return (
    <div>
      <Image
        id="ProfileImage"
        publicId={props.profilePicId}
        cloudName="dfno6k3qf"
        secure="true"
      >
        <Transformation
          radius="max"
          width="100"
          height="100"
          gravity="face"
          dpr="auto"
          crop="fill"
        />
      </Image>
    </div>
  );
}

// function _UserProfileFollowersFollowing(
//   props: UserProfileHeaderConfig
// ): JSX.Element {
//   return (
//     <div id="UserProfileFollowerContainer">
//       <span className="UserFollow">
//         <span className="FollowNumber">{props.followersCount}</span> followers
//       </span>
//       <span className="UserFollow">
//         <span className="FollowNumber">{props.followingCount}</span> following
//       </span>
//     </div>
//   );
// }

function _UserProfileHeader(props: UserProfileHeaderConfig): JSX.Element {
  return (
    <div id="UserProfileInfoContainer">
      {_ProfilePicture({ ...props })}
      <span id="ProfileUserName">{props.userName}</span>
      <span id="ProfileUserHandle">@{props.userHandleRenderedForm}</span>
      {/* {_UserProfileFollowersFollowing({ ...props })} */}

      <div className="UserProfileBio">{props.userBio}</div>
    </div>
  );
}

export function UserProfileHeader(props: UserProfileHeaderConfig): JSX.Element {
  return (
    <div>
      <_UserProfileHeader {...props} />
    </div>
  );
}
